import {defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {sentConstants, uriConstants} from "../../constants";

export const sentActions = {
  readSentList,
  readOrgSentList,
  selectSentInfo,
  changeSearchInfo,
  getSentInfo,
  // changeFileRow,
  onCollection,
  settingHistory,
  subSentDocPdf,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 송신함 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: sentConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}


/*********
 송신함 리스트 조회
 **********/

function readSentList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )
    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_SENT_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }

  function request() {
    return {
      type: sentConstants.SENT_REQUEST
    }
  }
  function success(response) {
    return {
      type: sentConstants.SENT_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: sentConstants.SENT_FAILURE,
      response
    }
  }
}

/*********
 송신함 원본 리스트 조회
 **********/

function readOrgSentList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_SENT_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }

  function request() {
    return {
      type: sentConstants.SENT_ORG_REQUEST
    }
  }
  function success(response) {
    return {
      type: sentConstants.SENT_ORG_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: sentConstants.SENT_ORG_FAILURE,
      response
    }
  }
}

/***********
 송신함 증명서 상세 선택
 ************/
function selectSentInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: sentConstants.SELECT_REQUEST,
      payload: info
    }
  }
}

/*********
 수신함 증명서 상세조회
 **********/

function getSentInfo(crtRcvSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_SENT_INFO + "/" + crtRcvSeq
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: sentConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: sentConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: sentConstants.DETAIL_FAILURE,
      response
    }
  }
}


// /***********
//  증명서 제출 첨부문서 row 최신화
//  ************/
// function changeFileRow(fileList) {
//   return async dispatch => {
//     dispatch(request(fileList))
//   }
//
//   function request() {
//     return {
//       type: sentConstants.CHANGE_FILE_REQUEST,
//       payload: fileList
//     }
//   }
// }


/***********
 증명서 송신함 문서회수
 ************/
function onCollection(params) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'put',
      endPoint: uriConstants.API_URI + uriConstants.WITHDRAW_SENT,
      params:params
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(alertActions.error({
                title: null,
                message: errorMessages.systemError
              }))
            }
        )
  }

  function request() {
    return {
      type: sentConstants.WITHDRAW_REQUEST
    }
  }
  function success(response) {
    return {
      type: sentConstants.WITHDRAW_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: sentConstants.WITHDRAW_FAILURE,
      response
    }
  }
}

/***********
 증명서 송신함 리스트 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: sentConstants.SENT_HISTORY,
      payload: history
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

/*********
 송신함 PDF 발급요청
 **********/

function subSentDocPdf(crtSeq) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'post',
      endPoint: uriConstants.API_URI + uriConstants.SUB_SENT_DOC_PDF,
      params: 'crtSeq='+ crtSeq
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: sentConstants.SUB_SENT_DOC_PDF_REQUEST
    }
  }
  function success(response) {
    return {
      type: sentConstants.SUB_SENT_DOC_PDF_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: sentConstants.SUB_SENT_DOC_PDF_FAILURE,
      response
    }
  }
}
